var React = require('react');

function FormBtnInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none"},[React.createElement("rect",{"width":"50","height":"50","fill":"#6DDDD7","rx":"25","key":0}),React.createElement("path",{"fill":"#FFF","d":"M30.5,24.134 C31.1667,24.5189 31.1667,25.4811 30.5,25.866 L23,30.1962 C22.3333,30.5811 21.5,30.0999 21.5,29.3301 L21.5,20.6699 C21.5,19.9001 22.3333,19.4189 23,19.8038 L30.5,24.134 Z","key":1})]));
}

FormBtnInline.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50"};

module.exports = FormBtnInline;

FormBtnInline.default = FormBtnInline;
